/**
 * Hook to resolve connector type for a workspace item.
 *
 * Reads from the tables list TanStack Query cache (already populated by the workspace),
 * falling back to the value stored on the PreviewItem.
 * Needed because the table detail endpoint doesn't include connector_type.
 */

import type { ConnectorType, WorkspaceItemType } from '@loader/shared-types';

import { useTablesListQuery } from '@/features/tables/hooks/useTableQueries';

export function useResolvedConnectorType(
  itemId: string,
  itemType: WorkspaceItemType | '',
  fallback?: ConnectorType | null
): ConnectorType | null {
  const { data: tablesList } = useTablesListQuery();

  if (itemType !== 'table') return null;

  return tablesList?.find((t) => t.id === itemId)?.connector_type ?? fallback ?? null;
}
